export const debut_sem = new Date(2020, 8, 14)
export const fin_sem = new Date(2021,0,9)
export const feries = [
        new Date(2020, 10, 1),
        new Date(2020, 10, 11)
    ]
export const vacances = [
        [new Date(2020, 9, 26), new Date(2020, 9, 31)],
        [new Date(2020, 11, 24), new Date(2021, 0, 2)]
    ]